import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, fmtCoins, baht } from "../ui";
import { useToast } from "../../context/ToastContext";
import api from "../../services/api";
import { errorInfo } from "../../services/errors";

const FRESH_MS = 2 * 60 * 60 * 1000; // แสดงเฉพาะรายการค้างภายใน 2 ชม. (QR หมดอายุแล้วไม่มีทางจ่าย)

/** รายการเติมเงินที่สร้าง QR แล้วแต่ยังไม่ได้ยืนยัน (ปิดหน้าต่างก่อน/จ่ายแล้วคอยน์ยังไม่เข้า) — ตรวจสอบซ้ำได้ปลอดภัย ไม่เติมซ้ำ */
export default function PendingTopups({ version, onConfirmed }) {
  const toast = useToast();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");

  const load = useCallback(() => api.coins.topups()
    .then((items) => setRows(items.filter((t) => t.status === "pending" && Date.now() - new Date(t.createdAt).getTime() < FRESH_MS)))
    .catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load, version]);

  const check = async (t) => {
    setBusy(t.id);
    try {
      if (t.kind === "create_credit") {
        const r = await api.credits.confirm(t.id);
        toast(`เพิ่ม ${fmtCoins(r.added ?? t.qty)} สิทธิ์สร้างตัวละครเรียบร้อย`, "success");
        onConfirmed(r);
        load();
        return;
      }
      const r = await api.coins.confirm(t.packageId, t.id);
      toast(`เติม ${fmtCoins(r.added ?? r.coins ?? t.coins)} คอยน์เรียบร้อย`, "success");
      onConfirmed(r);
      load();
    } catch (e) {
      const info = errorInfo(e);
      toast(info.code === "payment_pending" ? "ยังไม่พบการชำระเงิน ถ้าเพิ่งจ่ายให้รอ 5-10 นาทีแล้วลองใหม่" : info.message, info.code === "payment_pending" ? "info" : "error");
    } finally {
      setBusy("");
    }
  };

  if (!rows.length) return null;
  return (
    <Card className="mt-16" aria-label="รายการเติมเงินที่รอยืนยัน">
      <div className="strong">รายการรอยืนยัน</div>
      <p className="muted" style={{ fontSize: 13 }}>ถ้าชำระเงินแล้วแต่คอยน์ยังไม่เข้า กดตรวจสอบได้ (ไม่เติมซ้ำ)</p>
      {rows.map((t) => (
        <div key={t.id} className="hist__row">
          <div className="grow"><div className="strong">{baht(t.amount)} · {t.kind === "create_credit" ? `${fmtCoins(t.qty)} สิทธิ์สร้างตัวละคร` : `${fmtCoins(t.coins)} คอยน์`}</div><div className="faint" style={{ fontSize: 12 }}>{new Date(t.createdAt).toLocaleString("th-TH", { dateStyle: "medium", timeStyle: "short" })}</div></div>
          <Button size="sm" disabled={busy === t.id} onClick={() => check(t)}>{busy === t.id ? "กำลังตรวจ..." : "ตรวจสอบ"}</Button>
        </div>
      ))}
    </Card>
  );
}
